import React, { useEffect, useState } from 'react';
import { useApp, api } from '@/context/AppContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Progress } from '@/components/ui/progress';
import { Sparkles, Languages } from 'lucide-react';

export default function TranslationsAdminPage() {
  const { t } = useApp();
  const [status, setStatus] = useState(null);

  const refresh = () => api.get('/ai/translate-goals/status').then(r => setStatus(r.data)).catch(() => {});

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 5000);
    return () => clearInterval(id);
  }, []);

  const start = async () => {
    await api.post('/ai/translate-goals/start');
    refresh();
  };

  const total = (status?.translated || 0) + (status?.pending || 0);
  const pct = total ? Math.round((status.translated / total) * 100) : 0;

  return (
    <main id="main" className="max-w-3xl mx-auto px-4 py-8" data-testid="translations-page">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><Languages className="w-5 h-5" />{t('translate_panel')}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-3 gap-3">
            <Stat label={t('translate_done')} value={status?.translated ?? '—'} />
            <Stat label={t('translate_pending')} value={status?.pending ?? '—'} />
            <Stat label="%" value={`${pct}%`} />
          </div>
          <Progress value={pct} className="h-3" />
          <div className="flex items-center gap-3">
            <Button onClick={start} disabled={status?.running} className="bg-primary" data-testid="translate-start-btn">
              <Sparkles className="w-4 h-4 me-2" />
              {status?.running ? t('translate_running') : t('translate_start')}
            </Button>
            {status?.running && <span className="text-sm text-muted-foreground">{t('translate_progress')}: {status.done}/{status.total}</span>}
          </div>
          {status?.last_error && (
            <div className="text-xs text-destructive border border-destructive/40 bg-destructive/5 rounded p-2 mt-2" data-testid="translate-error">{status.last_error}</div>
          )}
        </CardContent>
      </Card>
    </main>
  );
}

function Stat({ label, value }) {
  return (
    <div className="border border-border rounded-lg p-4">
      <div className="text-xs text-muted-foreground font-semibold mb-1">{label}</div>
      <div className="text-2xl font-black text-primary">{value}</div>
    </div>
  );
}
